import React, { useEffect, useState } from 'react';
import {
  Redirect,
} from 'react-router-dom';
import { getReferenceFromInvite } from '../../services/loanRetrievalService';
import SITE_PATHS from '../../config/sitePaths';
import Text from '../../components/Text';

export default function Standalone(props) {
  const queryString = new URLSearchParams(props.location.search);
  const requestId = queryString.get('requestId');
  const ref = queryString.get('ref');
  const [isLoading, setIsLoading] = useState(true);
  const [inviteResponse, setInviteResponse] = useState(null);

  useEffect(() => {
    const initialize = async () => {
      try {
        const result = await getReferenceFromInvite(
          null,
          requestId,
          ref,
        );
        setInviteResponse(result);
      } catch (error) {
        console.error('Error loading standalone:', error); // eslint-disable-line no-console
      } finally {
        setIsLoading(false);
      }
    };
    initialize();
  }, [requestId, ref]);

  if (isLoading) return null;
  if (!inviteResponse?.clientId || !inviteResponse.requestId) {
    return (
      <div className="font-weight-bold mt-4">
        <Text value="Unable to load Smart Consent link." />
      </div>
    );
  }
  const state = {
    ...inviteResponse,
    requestId,
    ref,
    autoConfirmLoan: true,
  };
  return (
    <Redirect
      from={SITE_PATHS.STANDALONE}
      to={{ pathname: SITE_PATHS.LOAN, state }}
    />
  );
}
